import React, {
    useMemo,
    useState,
    useEffect
} from "react";

import {
    Layout,
    Menu,
    Drawer,
    Button,
    Typography,
    Input
} from "antd";

import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    DashboardOutlined,
    CalendarOutlined,
    TeamOutlined,
    ReadOutlined,
    UsergroupAddOutlined,
    SearchOutlined,
    CheckCircleOutlined,
    SolutionOutlined,
    ApartmentOutlined,
    BookOutlined,
    FileTextOutlined,
    FileSearchOutlined,
    PaperClipOutlined,
    TrophyOutlined,
    LineChartOutlined,
    FileDoneOutlined,
    IdcardOutlined,
    CheckSquareOutlined
} from "@ant-design/icons";

import {
    FaClipboardList,
    FaChalkboardTeacher,
    FaUserGraduate
} from "react-icons/fa";

import { motion } from "framer-motion";


// =========================================================
// SMART ID / TEACHER ATTENDANCE
// =========================================================

import TeacherAttendanceScanner
    from "./SmartIDCardScaner/TeacherAttendanceScanner";

import TeacherSmartCardManagement
    from "./SmartIDCardScaner/TeacherSmartCardManagement";

import TeacherScannerDeviceManagement
    from "./SmartIDCardScaner/TeacherScannerDeviceManagement";

import TeacherSmartAttendanceDashboard
    from "./SmartIDCardScaner/TeacherSmartAttendanceDashboard";


// =========================================================
// TODO / CALENDAR
// =========================================================

import PostTodoList
    from "./CalenderAndTodo/PostTodoList";


// =========================================================
// TEACHERS
// =========================================================

import PrintTestByClass
    from "../pages/Teachers/PrintTestByClass";

import ViewLessonPlan
    from "../pages/Teachers/ViewLessonPlan";

import TeacherDataForm
    from "../pages/Teachers/TeacherDataForm";

import SupportStaff
    from "../pages/Teachers/SupportStaff";

import AssignmentView
    from "../pages/Teachers/AssignmentView";

import GetStudentNotes
    from "../pages/Teachers/GetStudentNotes";

import TestPraint
    from "../pages/Teachers/TestPraint";


// =========================================================
// DASHBOARD
// =========================================================

import OverviewAdmission
    from "./pages/OverviewAdmission";


// =========================================================
// STUDENTS
// =========================================================

import UserSearchBox
    from "../SchoolDashApp/UserDetails/UserSearchBox";

import UserDetailsPage
    from "../SchoolDashApp/UserDetails/UserDetailsPage";

import ProfileImage
    from "./ProfileImage";

import AdmissionForm
    from "./NewStudents/AdmissionForm/AdmissionForm";

import StudentAdmission
    from "./NewStudents/AdmissionForm/StudentAdmission";


// =========================================================
// ACADEMICS
// =========================================================

import ClassViewList
    from "../SchoolDashApp/Class/ClassViewList";

import SubjectViewList
    from "../SchoolDashApp/Class/Subjects/SubjectViewList";


// =========================================================
// ATTENDANCE
// =========================================================

import AttendanceRecord
    from "../pages/Attendance/AttendanceRecord";

import AttendanceData
    from "../pages/Attendance/AttendanceData";


// =========================================================
// REPORTS / GRADES
// =========================================================

import GradeDistribution
    from "../pages/Reportcard/GradeDistribution";

import ReportCard
    from "./ReportCard";

import HighAveragesPage
    from "../SchoolDashApp/ReportCard/HighAveragesPage";

import StudentStatusSummary
    from "../SchoolDashApp/StudentStatusSummary";

import PeriodReport
    from "../pages/Reportcard/PeriodReport";

import BulkTestScorePage
    from "../SchoolDashApp/ReportCard/BulkTestScorePage";

import TopStudentPerPeriod
    from "../SchoolDashApp/ReportCard/TopStudentPerPeriod";


// =========================================================
// TEST ATTACHMENTS
// =========================================================

import TestAttachmentView
    from "../SchoolDashApp/TestAttachmentView";


// =========================================================
// STUDENT ID CARDS
// =========================================================

import StudentsIDCard
    from "../pages/Students/IdCards/StudentsIDCard";


// =========================================================
// UI
// =========================================================

import Darkmode
    from "./Darkmode/Darkmode";

import NotificationIcon
    from "../components/ChatApp/NotificationIcon";

import Notice
    from "../components/ChatApp/Notice";


// =========================================================
// LOGO
// =========================================================

import logo
    from "./assets/savationChristLogo.png";


const {
    Header,
    Sider,
    Content
} = Layout;

const {
    Title,
    Text
} = Typography;


// =========================================================
// VPA SIDEBAR ACCESS
// =========================================================
//
// VPA = Vice Principal Academic
//
// The VPA is intentionally restricted to:
//
// 1. Dashboard
// 2. Students
// 3. Classes & Subjects
// 4. Teachers & Staff
// 5. Assignments / Notes
// 6. Student Attendance
// 7. Academic Assessment
// 8. Academic Reports
// 9. Teacher Attendance
// 10. Student ID Cards
//
// NO:
// - Finance
// - Fees
// - Payments
// - Payroll
// - Loans
// - Expenditure
// - Financial Reports
// - System Settings
// - Blacklist management
// - User administration
// =========================================================


const VPA_MENU_ITEMS = [

    // =====================================================
    // DASHBOARD
    // =====================================================

    {
        key: "overview",
        icon: <DashboardOutlined />,
        label: "Dashboard"
    },


    // =====================================================
    // STUDENTS
    // =====================================================

    {
        key: "students",
        type: "group",
        label: "STUDENTS",
        children: [

            {
                key: "admissionlist",
                icon: <FaUserGraduate />,
                label: "Students List"
            },

            {
                key: "statusrecord",
                icon: <SolutionOutlined />,
                label: "Students Status"
            },

            {
                key: "studentidcards",
                icon: <IdcardOutlined />,
                label: "Student ID Cards"
            }

        ]
    },


    // =====================================================
    // ACADEMICS
    // =====================================================

    {
        key: "academics",
        type: "group",
        label: "ACADEMICS",
        children: [

            {
                key: "classviewlist",
                icon: <ApartmentOutlined />,
                label: "Grade Classes"
            },

            {
                key: "subjectviewlist",
                icon: <BookOutlined />,
                label: "Subjects"
            },

            {
                key: "viewlessonplan",
                icon: <FaChalkboardTeacher />,
                label: "Teacher Lesson Plans"
            },

            {
                key: "studentsassignments",
                icon: <FaClipboardList />,
                label: "Students Assignments"
            },

            {
                key: "studentsnotes",
                icon: <ReadOutlined />,
                label: "Students Notes"
            }

        ]
    },


    // =====================================================
    // TEACHERS & STAFF
    // =====================================================

    {
        key: "teachers",
        type: "group",
        label: "TEACHERS & STAFF",
        children: [

            {
                key: "teacherdata",
                icon: <FaChalkboardTeacher />,
                label: "Teacher Data"
            },

            {
                key: "supportstaff",
                icon: <TeamOutlined />,
                label: "Support Staff"
            },

            {
                key: "getteachernotes",
                icon: <FileTextOutlined />,
                label: "Teacher Notes"
            }

        ]
    },


    // =====================================================
    // ATTENDANCE
    // =====================================================

    {
        key: "attendance",
        type: "group",
        label: "ATTENDANCE",
        children: [

            {
                key: "attendancerecord",
                icon: <CheckCircleOutlined />,
                label: "Student Attendance"
            },

            {
                key: "attendancedata",
                icon: <CalendarOutlined />,
                label: "Attendance Data"
            },

            {
                key: "teachersmartattendancedashboard",
                icon: <FaChalkboardTeacher />,
                label: "Teacher Attendance"
            },

            {
                key: "teacherattendancescanner",
                icon: <FaChalkboardTeacher />,
                label: "Attendance Scanner"
            }

        ]
    },


    // =====================================================
    // ASSESSMENTS
    // =====================================================

    {
        key: "assessment",
        type: "group",
        label: "ASSESSMENTS",
        children: [

            {
                key: "bulkgrades",
                icon: <FaChalkboardTeacher />,
                label: "Bulk Grades"
            },

            {
                key: "testprint",
                icon: <FileSearchOutlined />,
                label: "Teacher Tests"
            },

            {
                key: "printtestbyclass",
                icon: <FileDoneOutlined />,
                label: "Print Tests by Class"
            },

            {
                key: "testattachmentview",
                icon: <PaperClipOutlined />,
                label: "Test Attachments"
            }

        ]
    },


    // =====================================================
    // ACADEMIC REPORTS
    // =====================================================

    {
        key: "reports",
        type: "group",
        label: "ACADEMIC REPORTS",
        children: [

            {
                key: "reportcard",
                icon: <FileTextOutlined />,
                label: "Report Cards"
            },

            {
                key: "periodicreport",
                icon: <FileDoneOutlined />,
                label: "Periodic Reports"
            },

            {
                key: "topstudents",
                icon: <TrophyOutlined />,
                label: "Top Students"
            },

            {
                key: "highaverages",
                icon: <LineChartOutlined />,
                label: "High Yearly Averages"
            },

            {
                key: "gradedistribution",
                icon: <LineChartOutlined />,
                label: "Grade Distribution"
            }

        ]
    },


    // =====================================================
    // TEACHER SMART CARD
    // =====================================================

    {
        key: "teacherattendance",
        type: "group",
        label: "TEACHER SMART ATTENDANCE",
        children: [

            {
                key: "teachersmartcardmanagement",
                icon: <IdcardOutlined />,
                label: "Teacher Card Management"
            },

            {
                key: "teacherscannerdevicemanagement",
                icon: <IdcardOutlined />,
                label: "Scanner Devices"
            }

        ]
    }

];


// =========================================================
// DASHBOARD
// =========================================================

const NewVpaDashboard = () => {

    const [collapsed, setCollapsed] =
        useState(false);

    const [drawerOpen, setDrawerOpen] =
        useState(false);

    const [darkMode, setDarkMode] =
        useState(false);

    const [activePage, setActivePage] =
        useState("overview");

    const [selectedUser, setSelectedUser] =
        useState(null);

    const [menuSearch, setMenuSearch] =
        useState("");

    const [todoOpen, setTodoOpen] =
        useState(false);

    const [isMobile, setIsMobile] =
        useState(window.innerWidth < 768);


    // =====================================================
    // RESPONSIVE
    // =====================================================

    useEffect(() => {

        const handleResize = () => {

            setIsMobile(
                window.innerWidth < 768
            );

        };

        window.addEventListener(
            "resize",
            handleResize
        );

        return () => {

            window.removeEventListener(
                "resize",
                handleResize
            );

        };

    }, []);


    // =====================================================
    // SCROLLBAR
    // =====================================================

    useEffect(() => {

        const style =
            document.createElement("style");

        style.innerHTML = `

            ::-webkit-scrollbar {
                width: 8px;
                height: 4px;
            }

            ::-webkit-scrollbar-track {
                background: transparent;
            }

            ::-webkit-scrollbar-thumb {
                background: #800000;
                border-radius: 10px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: #5a0000;
            }

            .vpa-sidebar-menu
                .ant-menu-item-group-title {
                font-size: 10px;
                font-weight: 700;
                letter-spacing: 0.8px;
                padding-left: 16px;
                margin-top: 8px;
            }

            .vpa-sidebar-menu
                .ant-menu-item {
                margin: 3px 8px;
                width: calc(100% - 16px);
                border-radius: 8px;
            }

            .vpa-sidebar-menu
                .ant-menu-submenu-title {
                border-radius: 8px;
                margin: 3px 8px;
                width: calc(100% - 16px);
            }

        `;

        document.head.appendChild(style);

        return () => {

            document.head.removeChild(style);

        };

    }, []);


    // =====================================================
    // THEME
    // =====================================================

    const theme = useMemo(() => ({

        darkMode,

        background:
            darkMode
                ? "#0f172a"
                : "#f5f7fb",

        sidebar:
            darkMode
                ? "#111827"
                : "#ffffff",

        header:
            darkMode
                ? "#111827"
                : "#ffffff",

        card:
            darkMode
                ? "#1e293b"
                : "#ffffff",

        inputBackground:
            darkMode
                ? "#1e293b"
                : "#ffffff",

        text:
            darkMode
                ? "#ffffff"
                : "#172033",

        secondary:
            darkMode
                ? "#cbd5e1"
                : "#64748b",

        border:
            darkMode
                ? "#334155"
                : "#e5e7eb",

        primary:
            "#2563eb"

    }), [darkMode]);


    // =====================================================
    // SEARCH MENU
    // =====================================================

    const filteredMenuItems = useMemo(() => {

        const search =
            menuSearch
                .trim()
                .toLowerCase();

        if (!search) {

            return VPA_MENU_ITEMS;

        }

        return VPA_MENU_ITEMS

            .map(section => {

                if (
                    section.type !== "group"
                ) {

                    return section.label
                        .toLowerCase()
                        .includes(search)
                        ? section
                        : null;

                }

                const children =
                    section.children.filter(
                        item =>
                            item.label
                                .toLowerCase()
                                .includes(search)
                    );

                if (
                    children.length === 0
                ) {

                    return null;

                }

                return {
                    ...section,
                    children
                };

            })

            .filter(Boolean);

    }, [menuSearch]);


    // =====================================================
    // PAGE RENDERING
    // =====================================================

    const renderPage = () => {

        // -------------------------------------------------
        // USER PROFILE
        // -------------------------------------------------

        if (selectedUser) {

            return (
                <UserDetailsPage
                    theme={theme}
                    selectedUser={selectedUser}
                />
            );

        }


        // -------------------------------------------------
        // VPA PAGES
        // -------------------------------------------------

        switch (activePage) {


            // =============================================
            // DASHBOARD
            // =============================================

            case "overview":

                return (
                    <OverviewAdmission
                        theme={theme}
                    />
                );


            // =============================================
            // STUDENTS
            // =============================================

            case "admissionlist":

                return (
                    <StudentAdmission
                        theme={theme}
                    />
                );


            case "statusrecord":

                return (
                    <StudentStatusSummary
                        theme={theme}
                    />
                );


            case "studentidcards":

                return (
                    <StudentsIDCard
                        theme={theme}
                    />
                );


            // =============================================
            // ACADEMICS
            // =============================================

            case "classviewlist":

                return (
                    <ClassViewList
                        theme={theme}
                    />
                );


            case "subjectviewlist":

                return (
                    <SubjectViewList
                        theme={theme}
                    />
                );


            case "viewlessonplan":

                return (
                    <ViewLessonPlan
                        theme={theme}
                    />
                );


            case "studentsassignments":

                return (
                    <AssignmentView
                        theme={theme}
                    />
                );


            case "studentsnotes":

                return (
                    <GetStudentNotes
                        theme={theme}
                    />
                );


            // =============================================
            // TEACHERS
            // =============================================

            case "teacherdata":

                return (
                    <TeacherDataForm
                        theme={theme}
                    />
                );


            case "supportstaff":

                return (
                    <SupportStaff
                        theme={theme}
                    />
                );


            case "getteachernotes":

                return (
                    <GetStudentNotes
                        theme={theme}
                    />
                );


            // =============================================
            // ATTENDANCE
            // =============================================

            case "attendancerecord":

                return (
                    <AttendanceRecord
                        theme={theme}
                    />
                );


            case "attendancedata":

                return (
                    <AttendanceData
                        theme={theme}
                    />
                );


            // =============================================
            // ASSESSMENTS
            // =============================================

            case "bulkgrades":

                return (
                    <BulkTestScorePage
                        theme={theme}
                    />
                );


            case "testprint":

                return (
                    <TestPraint
                        theme={theme}
                    />
                );


            case "printtestbyclass":

                return (
                    <PrintTestByClass
                        theme={theme}
                    />
                );


            case "testattachmentview":

                return (
                    <TestAttachmentView
                        theme={theme}
                    />
                );


            // =============================================
            // REPORTS
            // =============================================

            case "reportcard":

                return (
                    <ReportCard
                        theme={theme}
                    />
                );


            case "periodicreport":

                return (
                    <PeriodReport
                        theme={theme}
                    />
                );


            case "topstudents":

                return (
                    <TopStudentPerPeriod
                        theme={theme}
                    />
                );


            case "highaverages":

                return (
                    <HighAveragesPage
                        theme={theme}
                    />
                );


            case "gradedistribution":

                return (
                    <GradeDistribution
                        theme={theme}
                    />
                );


            // =============================================
            // TEACHER SMART ATTENDANCE
            // =============================================

            case "teachersmartattendancedashboard":

                return (
                    <TeacherSmartAttendanceDashboard
                        theme={theme}
                    />
                );


            case "teacherattendancescanner":

                return (
                    <TeacherAttendanceScanner
                        theme={theme}
                    />
                );


            case "teachersmartcardmanagement":

                return (
                    <TeacherSmartCardManagement
                        theme={theme}
                    />
                );


            case "teacherscannerdevicemanagement":

                return (
                    <TeacherScannerDeviceManagement
                        theme={theme}
                    />
                );


            // =============================================
            // SAFETY FALLBACK
            // =============================================

            default:

                return (
                    <OverviewAdmission
                        theme={theme}
                    />
                );

        }

    };


    // =====================================================
    // SIDEBAR
    // =====================================================

    const sidebar = (

        <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                background: theme.sidebar
            }}
        >

            {/* =================================================
                LOGO
            ================================================= */}

            <div
                style={{
                    height: 75,
                    flexShrink: 0,

                    display: "flex",
                    alignItems: "center",

                    gap: 12,

                    padding:
                        "0 18px",

                    borderBottom:
                        `1px solid ${theme.border}`
                }}
            >

                <img
                    src={logo}
                    alt="Salvation In Christ School System"
                    style={{
                        width: 42,
                        height: 42,
                        borderRadius: 12,
                        objectFit: "cover"
                    }}
                />


                {!collapsed && (

                    <div
                        style={{
                            minWidth: 0
                        }}
                    >

                        <Title
                            level={5}
                            style={{
                                margin: 0,
                                color: theme.text,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            Salvation In Christ
                        </Title>


                        <Text
                            style={{
                                fontSize: 11,
                                color: theme.secondary
                            }}
                        >
                            VPA Academic Portal
                        </Text>

                    </div>

                )}

            </div>


            {/* =================================================
                PROFILE
            ================================================= */}

            {!collapsed && (

                <div
                    style={{
                        flexShrink: 0
                    }}
                >

                    <ProfileImage
                        theme={theme}
                    />

                </div>

            )}


            {/* =================================================
                MENU SEARCH
            ================================================= */}

            {!collapsed && (

                <div
                    style={{
                        flexShrink: 0,

                        padding:
                            "12px 12px 7px",

                        background:
                            theme.sidebar
                    }}
                >

                    <Input
                        allowClear
                        value={menuSearch}
                        onChange={e =>
                            setMenuSearch(
                                e.target.value
                            )
                        }
                        placeholder="Search VPA menu..."
                        prefix={
                            <SearchOutlined />
                        }
                    />

                </div>

            )}


            {/* =================================================
                MENU
            ================================================= */}

            <div
                style={{
                    flex: 1,
                    minHeight: 0,

                    overflowY: "auto",
                    overflowX: "hidden"
                }}
            >

                <Menu
                    className="vpa-sidebar-menu"

                    mode="inline"

                    items={
                        filteredMenuItems
                    }

                    selectedKeys={[
                        activePage
                    ]}

                    inlineCollapsed={
                        collapsed
                    }

                    onClick={({
                        key
                    }) => {

                        setActivePage(
                            key
                        );

                        setSelectedUser(
                            null
                        );

                        setMenuSearch(
                            ""
                        );

                        if (
                            isMobile
                        ) {

                            setDrawerOpen(
                                false
                            );

                        }

                    }}

                    theme={
                        darkMode
                            ? "dark"
                            : "light"
                    }

                    style={{
                        background:
                            "transparent",

                        border: "none"
                    }}
                />

            </div>


            {/* =================================================
                SIDEBAR FOOTER
            ================================================= */}

            <div
                style={{
                    height: 55,
                    flexShrink: 0,

                    display: "flex",
                    alignItems: "center",

                    padding:
                        "0 15px",

                    borderTop:
                        `1px solid ${theme.border}`,

                    background:
                        theme.sidebar
                }}
            >

                {!collapsed && (

                    <Text
                        style={{
                            fontSize: 11,
                            color:
                                theme.secondary
                        }}
                    >
                        © 2026 Salvation In Christ
                    </Text>

                )}

            </div>

        </div>

    );


    // =====================================================
    // MAIN DASHBOARD
    // =====================================================

    return (

        <div
            style={{
                position: "fixed",

                top: 0,
                left: 0,
                right: 0,
                bottom: 0,

                zIndex: 999,

                background:
                    theme.background,

                overflow: "auto"
            }}
        >

            <Layout
                style={{
                    minHeight:
                        "100vh",

                    background:
                        theme.background
                }}
            >


                {/* =================================================
                    DESKTOP SIDEBAR
                ================================================= */}

                {!isMobile && (

                    <Sider
                        width={260}
                        collapsedWidth={75}
                        collapsed={collapsed}

                        style={{
                            position:
                                "fixed",

                            height:
                                "100vh",

                            background:
                                theme.sidebar,

                            borderRight:
                                `1px solid ${theme.border}`,

                            overflow:
                                "hidden",

                            zIndex: 20
                        }}
                    >

                        {sidebar}

                    </Sider>

                )}


                {/* =================================================
                    MOBILE SIDEBAR
                ================================================= */}

                {isMobile && (

                    <Drawer
                        open={
                            drawerOpen
                        }

                        width={280}

                        bodyStyle={{
                            padding: 0
                        }}

                        onClose={() =>
                            setDrawerOpen(
                                false
                            )
                        }
                    >

                        {sidebar}

                    </Drawer>

                )}


                {/* =================================================
                    MAIN LAYOUT
                ================================================= */}

                <Layout
                    style={{
                        marginLeft:
                            isMobile
                                ? 0
                                : collapsed
                                    ? 75
                                    : 260,

                        background:
                            theme.background
                    }}
                >


                    {/* =================================================
                        HEADER
                    ================================================= */}

                    <Header
                        style={{
                            height:
                                isMobile
                                    ? 60
                                    : 70,

                            padding:
                                isMobile
                                    ? "0 8px"
                                    : "0 20px",

                            display:
                                "flex",

                            alignItems:
                                "center",

                            justifyContent:
                                "space-between",

                            background:
                                theme.header,

                            borderBottom:
                                `1px solid ${theme.border}`,

                            position:
                                "sticky",

                            top: 0,

                            zIndex: 10,

                            overflow:
                                "hidden"
                        }}
                    >


                        {/* =================================================
                            HEADER LEFT
                        ================================================= */}

                        <div
                            style={{
                                display:
                                    "flex",

                                alignItems:
                                    "center",

                                gap:
                                    isMobile
                                        ? 5
                                        : 15,

                                minWidth: 0,

                                flex: 1
                            }}
                        >

                            <Button
                                shape="circle"

                                icon={

                                    isMobile

                                        ? (
                                            <MenuUnfoldOutlined />
                                        )

                                        : collapsed

                                            ? (
                                                <MenuUnfoldOutlined />
                                            )

                                            : (
                                                <MenuFoldOutlined />
                                            )

                                }

                                onClick={() => {

                                    if (
                                        isMobile
                                    ) {

                                        setDrawerOpen(
                                            true
                                        );

                                    } else {

                                        setCollapsed(
                                            !collapsed
                                        );

                                    }

                                }}

                            />


                            <div
                                style={{
                                    flex: 1,
                                    minWidth: 0
                                }}
                            >

                                <UserSearchBox
                                    theme={theme}

                                    setSelectedUser={
                                        setSelectedUser
                                    }

                                    setActiveComponent={
                                        setActivePage
                                    }

                                />

                            </div>

                        </div>


                        {/* =================================================
                            TODO
                        ================================================= */}

                        <div
                            style={{
                                margin:
                                    isMobile
                                        ? "0 8px"
                                        : "0 20px"
                            }}
                        >

                            <CheckSquareOutlined
                                style={{
                                    fontSize:
                                        isMobile
                                            ? 21
                                            : 25,

                                    cursor:
                                        "pointer",

                                    color:
                                        "#f97316"
                                }}

                                onClick={() =>
                                    setTodoOpen(
                                        true
                                    )
                                }
                            />


                            <PostTodoList
                                open={
                                    todoOpen
                                }

                                setOpen={
                                    setTodoOpen
                                }
                            />

                        </div>


                        {/* =================================================
                            HEADER RIGHT
                        ================================================= */}

                        <div
                            style={{
                                display:
                                    "flex",

                                alignItems:
                                    "center",

                                gap:
                                    isMobile
                                        ? 7
                                        : 18,

                                flexShrink: 0
                            }}
                        >


                            {/* DARK MODE */}

                            <Darkmode
                                darkMode={
                                    darkMode
                                }

                                setDarkMode={
                                    setDarkMode
                                }
                            />


                            {/* NOTIFICATIONS */}

                            <div
                                style={{
                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    gap: 8
                                }}
                            >

                                <NotificationIcon
                                    theme={
                                        theme
                                    }
                                />

                                <Notice />

                            </div>


                            {/* PROFILE */}

                            <div
                                style={{
                                    width:
                                        isMobile
                                            ? 34
                                            : 45,

                                    height:
                                        isMobile
                                            ? 34
                                            : 45,

                                    overflow:
                                        "hidden",

                                    borderRadius:
                                        "50%",

                                    display:
                                        "flex",

                                    alignItems:
                                        "center",

                                    justifyContent:
                                        "center"
                                }}
                            >

                                <ProfileImage
                                    theme={
                                        theme
                                    }

                                    header
                                />

                            </div>

                        </div>

                    </Header>


                    {/* =================================================
                        CONTENT
                    ================================================= */}

                    <Content
                        style={{
                            padding:
                                isMobile
                                    ? 12
                                    : 20,

                            background:
                                theme.background,

                            minHeight:
                                "calc(100vh - 70px)",

                            overflowY:
                                "auto"
                        }}
                    >

                        <motion.div

                            initial={{
                                opacity: 0,
                                y: 15
                            }}

                            animate={{
                                opacity: 1,
                                y: 0
                            }}

                            transition={{
                                duration:
                                    0.3
                            }}
                        >

                            {renderPage()}

                        </motion.div>

                    </Content>

                </Layout>

            </Layout>

        </div>

    );

};


export default NewVpaDashboard;